import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import debounce from "lodash/debounce";

import {Input} from "react-materialize";

import getQuotationOptionsThunk from "../../actions/workflow/isdnMigrationActions/getQuotationOptionsThunk";
import updateQuotationOptionsThunk from "../../actions/workflow/isdnMigrationActions/updateQuotationOptionsThunk";
import quotationActions from "../../actions/quotationActions";
import partnerServicesActions from "../../actions/partnerServicesActions";

import InputNumberWrapper from './InputNumberWrapper';

class ITServiceOptionWrapper extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selections: [],
    }
  }

  componentDidMount() {
    this.saveSelections = debounce(this.saveSelections, 1000);

    const selections = this.props.partnerServices.itServicesSelections;
    this.setState({
      selections: selections.filter(selection => selection.category === this.props.category)
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const selections = this.props.partnerServices.itServicesSelections;
    const oldSelections = prevProps.partnerServices.itServicesSelections;

    if (oldSelections !== selections) {
      this.setState({
        selections: [...selections.filter(selection => selection.category === this.props.category)]
      })
    }
  }

  saveSelections = (selections, quotationId, type) => {
    const {itServicesSelections} = this.props.partnerServices;
    const {category} = this.props;

    const allSelections = itServicesSelections.filter(selection => selection.category !== category);
    const newSelections = [...allSelections, ...selections];

    this.props.partnerServicesActions.persistPartnerServicesSelections(newSelections, quotationId, type).then(() => {
      this.props.partnerServicesActions.setITServiceSelection(newSelections);
    });
  };

  addOption = () => {
    if (this.props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    const {selections} = this.state;
    const {allowDecimalQuantity} = this.props;

    const quantityStep = allowDecimalQuantity ? 0.01 : 1;

    selections.push({
      id: '',
      quantity: quantityStep,
      category: ''
    });

    this.setState({selections});
  };

  dependencyCheck = (optionId) => {
    let {optionsList} = this.props;
    let selectedOption = optionsList.find(el => el.id === optionId);
    let childServices = selectedOption && selectedOption.partner_related_partner_products.length > 0 ?
      selectedOption.partner_related_partner_products.map(el => el.id) : [];

    if (childServices.length === 0) {
      return;
    }

    let {selections} = this.state;
    let selectionsIds = selections && selections.length > 0 ? selections.map((el) => el.id) : [];

    childServices.forEach((childService) => {
      if (selectionsIds.includes(childService)) {
        let foundIndex = selections.findIndex((selection) => {
          return childService === selection.id
        });
        selections.splice(foundIndex, 1);
      }
    });

    this.setState({selections: selections});
  };

  removeOption = (optionId, index) => {
    if (this.props.quotation.currentQuotation.inputsDisabled) {
      return;
    }

    this.dependencyCheck(optionId);
    const {selections} = this.state;
    selections.splice(index, 1);

    this.saveSelections(selections, this.props.quotation.currentQuotation.id, 'it');
    this.setState({selections});
  };

  onChange = (event, index, oldOptionId) => {
    if (this.props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    const {value} = event.target;
    const {category, allowDecimalQuantity} = this.props;
    this.dependencyCheck(oldOptionId);

    let {selections} = this.state;

    selections[index].id = parseInt(value);
    selections[index].category = category;

    const foundSelectedIndex = selections.findIndex((selection, idx) => selection.id === parseInt(value) && idx !== index);
    if (foundSelectedIndex !== -1) {

      if (selections[foundSelectedIndex].quantity >= 999) {
        return;
      }

      if (allowDecimalQuantity) {
        selections[index].quantity = (parseFloat(selections[index].quantity)
          + parseFloat(selections[foundSelectedIndex].quantity)).toFixed(2);
      } else {
        selections[index].quantity = parseInt(selections[index].quantity)
          + parseInt(selections[foundSelectedIndex].quantity);
      }

      selections.splice(foundSelectedIndex, 1);
    }

    this.setState({selections});

    this.saveSelections(selections, this.props.quotation.currentQuotation.id, 'it');
  };

  changeQuantity = (event, index) => {
    if (this.props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    let {value, min, max} = event.target;
    let {selections} = this.state;

    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    selections[index].quantity = parseInt(value).toString();

    this.setState({selections});

    //filter selections to not send null ids
    selections = selections.filter(selection => selection.id != null) || [];

    this.saveSelections(selections, this.props.quotation.currentQuotation.id, 'it');
  }

  changeDecimalQuantity = (value, index) => {
    if (this.props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    let {selections} = this.state;

    selections[index].quantity = value;

    this.setState({selections});

    //filter selections to not send null ids
    selections = selections.filter(selection => selection.id != null) || [];

    this.saveSelections(selections, this.props.quotation.currentQuotation.id, 'it');
  };

  renderQuantityInput = (option, index) => {
    const {allowDecimalQuantity} = this.props;
    const quantityStep = allowDecimalQuantity ? 0.01 : 1;
    let optionQuantity = option.quantity ? option.quantity : 1;
    const {selections} = this.state;
    const {inputsDisabled} = this.props.quotation.currentQuotation;

    return (
      !allowDecimalQuantity ?
        <Input
          s={1}
          type="number"
          label={index === 0 ? 'aantal' : ''}
          style={{marginBottom: selections?.length > 1 ? '15px' : null}}
          value={optionQuantity}
          onChange={(e) => {
            this.changeQuantity(e, index)
          }}
          step={quantityStep}
          min={quantityStep}
          max={999}
          disabled={inputsDisabled}
        /> :
        <InputNumberWrapper
          s={1}
          label="aantal"
          optionQuantity={optionQuantity}
          index={index}
          changeDecimalQuantity={this.changeDecimalQuantity}
          step={quantityStep}
          min={quantityStep}
          max={999}
          precision={2}
          className={'col input-field s1'}
          inputsDisabled={inputsDisabled}
        />

    );
  };

  renderOptions = (optionId) => {
    let excludedServices = [];
    let {optionsList} = this.props;
    let selectedOption = optionsList.find(el => el.id === optionId);
    let selectionsIds = this.state.selections && this.state.selections.length > 0 ? this.state.selections.map((el) => el.id) : [];
    let parentServices = optionsList.filter((el) => {
      return el.partner_related_partner_products && el.partner_related_partner_products.length > 0 &&
        !selectionsIds.includes(el.id)
    });

    parentServices.forEach((parentService) => {
      parentService.partner_related_partner_products.forEach((relatedProduct) => {
        excludedServices = [...excludedServices, relatedProduct];
      })
    });

    let excludedServicesIds = excludedServices.map((el) => el.id);
    let childServices = selectedOption && selectedOption.partner_related_partner_products.length > 0 ?
      selectedOption.partner_related_partner_products.map(el => el.id) : [];

    let filteredOptions = optionsList.filter((el) => !excludedServicesIds.includes(el.id) && !childServices.includes(el.id));

    // Sort alphabetically
    filteredOptions = filteredOptions.sort((a, b) => a.name.localeCompare(b.name));

    return filteredOptions.map((optionItem) =>
      <option key={optionItem.id} value={optionItem.id}>{optionItem.name}</option>
    )
  };

  render() {
    let {optionsList, category, allowDecimalQuantity} = this.props;
    const {selections} = this.state;
    const {inputsDisabled} = this.props.quotation.currentQuotation;

    const quantityStep = allowDecimalQuantity ? 1.00 : 1;

    if (!selections.length) {
      selections.push({
        id: "",
        quantity: quantityStep,
        category: this.props.category
      });
    }

    return (
      <fieldset disabled={inputsDisabled} style={{border: 'none', padding: 'unset', margin: 'unset'}}>
        <div className="row">
          <h1 className={'ratio-section-title'} style={{marginTop: 0}}>
            <span className="ratio-section-title">
              <i className="small material-icons left ratio-section-title">call_merge</i>IT Diensten
            </span> {this.props.category}
          </h1>
        </div>

        {selections.map((option, index) => {
          return (
            <div className="row" key={`${index}`} style={{marginBottom: 0}}>
              {option.id > 0 && this.renderQuantityInput(option, index)}

              <Input
                s={!option?.id ? 8 : 7}
                name='product'
                type='select'
                className={selections?.length > 1 && !(selections?.length - 1 === index) ? "ratio-input" : ''}
                label={index === 0 ? `Kies de gewenste ${category.toLowerCase()}` : ''}
                value={option.id}
                onChange={(e) => {
                  this.onChange(e, index, option.id)
                }}
                multiple={false}
                disabled={inputsDisabled}
              >
                <option value="">Selecteer</option>
                {this.renderOptions(option.id)}
              </Input>

              <button
                className='btn doceri-btn-right ratio-btn-right'
                onClick={() => this.removeOption(option.id, index)}
                style={{float: 'left', marginLeft: 10}}
                disabled={inputsDisabled}
              >
                Verwijder
              </button>

              {optionsList && selections.length - 1 === index ?
                <button className="btn doceri-btn-right ratio-btn-right" onClick={this.addOption}
                        disabled={inputsDisabled}>
                  {category} toevoegen
                </button> : null
              }
            </div>
          );
        })}
      </fieldset>
    )
  }
}

const mapStateToProps = ({quotation, quotationOptions, partnerServices, authentication}) => {
  return {
    quotation,
    quotationOptions,
    partnerServices,
    authentication
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getQuotationOptions: bindActionCreators(getQuotationOptionsThunk, dispatch),
    updateQuotationOptions: bindActionCreators(updateQuotationOptionsThunk, dispatch),
    quotationActions: bindActionCreators(quotationActions, dispatch),
    partnerServicesActions: bindActionCreators(partnerServicesActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ITServiceOptionWrapper);
